import React, { useEffect, useState } from 'react';
import { Grid, GridCellProps, GridRowProps, GridColumn as Column, GridItemChangeEvent } from "@progress/kendo-react-grid";
import * as Utils from '../../../../utils/EllowUtils'
import Styles from "./styles.module.scss"
import SideMenu from "../../sideMenu";
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import { makeSideBarActive } from '../../../../utils/EllowUtils';
import Headline4 from "../../../../components/headings/Headline4";
import Button from "../../../../components/button";
import ellowLogo from "../../../../assets/images/ellow-logo.svg";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { FormAreaInput } from '../../../../wrappers/formArea'
import { REACT_APP_CANDIDATE_FREELANCER } from '../../../../utils/common'
import AWS, { S3 } from 'aws-sdk';
import { useLocation } from "react-router-dom";
import { getTimesheetDetails, saveTimeSheetInvoiceDetail } from './services'
import NotificationAlert from "../../../../components/notification";
import rupeeIndian from "../../../../assets/images/rupee-indian.png";
import { useNavigate } from "react-router-dom";
import { postAPI, uploadApi } from '../../../../api/apis';

const InvoiceGenerator = () => {

    const navigate = useNavigate()
    const location = useLocation();
    const [notification, setNotification] = useState<boolean>(false)
    const { timesheetId }: any = location.state || ''
    const { candidateId }: any = location.state || '' 
    const { candidateJobId }: any = location.state || '' 
    const employeeId = localStorage.getItem('employee_id')
    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 1)
    const [mobile, setMobile] = useState('');
    const [errorMobile, setErrorMobile] = useState('This field is required');
    const [name, setName] = useState('');
    const [errorName, setErrorName] = useState('This field is required');
    const [bankName, setBankName] = useState('');
    const [errorBankName, setErrorBankName] = useState('This field is required');
    const [accountNo, setAccountNo] = useState('');
    const [errorAccountNo, setErrorAccountNo] = useState('This field is required');
    const [ifsc, setIfsc] = useState('');
    const [errorIfsc, setErrorIfsc] = useState('This field is required');
    const [branch, setBranch] = useState('');
    const [errorBranch, setErrorBranch] = useState('This field is required');
    const [billFrom, setBillFrom] = useState('');
    const [errorBillFrom, setErrorBillFrom] = useState('This field is required');
    const [panNo, setPanNo] = useState('');
    const [errorPanNo, setErrorPanNo] = useState('This field is required');
    const [candidateName, setCandidateName] = useState<any>()
    const [companyName, setCompanyName] = useState<any>()
    const [designation, setDesignation] = useState<any>()
    const [showMessage, setShowMessage] = useState(false);
    const [timesheetData, setTimeSheetData] = useState<any>([]);
    const [candidatePay, setCandidatePay] = useState<any>()
    const [tdsAmount, setTdsAmount] = useState<any>()
    const [gstAmount, setGstAmount] = useState<any>()
    const [netPayableAmount, setNetPayableAmount] = useState<any>()
    const [candidateOverallPay, setCandidateOverallPay] = useState<any>()
    const [invoiceNo, SetInvoiceNo] = useState((Math.random() + 1).toString(36).substring(7));
    const pdfExportComponent = React.useRef<PDFExport>(null);
    const currentDate = new Date();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
        "July", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const dd = String(currentDate.getDate()).padStart(2, '0');
    const mm = monthNames[currentDate.getMonth()]; //January is 0!
    const yyyy = currentDate.getFullYear();
    const today = dd + '-' + mm + '-' + yyyy;
    
    useEffect(() => {
        getTimeSheetData(timesheetId);
    }, []);

    const getTimeSheetData = (timesheetId: string) => {
        getTimesheetDetails(timesheetId).then((response) => {
            if (response && response.status === 1) {
                setTimeSheetData(response.data)
                setCandidateName(response.data[0].candidateName)
                setCompanyName(response.data[0].companyName)
                setDesignation(response.data[0].position)
                SetInvoiceNo(response.data[0].invoiceNo)
                setCandidatePay(response.data[0].candidateOverallPay)
                setTdsAmount(response.data[0].tdsAmountCandidate)
                setGstAmount(response.data[0].gstAmountCandidate)
                setCandidateOverallPay(response.data[0].candidateOverallPay)
                setNetPayableAmount(response.data[0].candidate_adjusted_overall_payment)
                let overAllPay = response.data[0].candidatePay
                response.data[0].arrears.map(function (item: any) {
                    if (item.type != '' && item.value != '') {
                      if (item.type == '%') {
                        overAllPay = overAllPay + ((overAllPay * parseInt(item.value)) / 100);
                      } else if (item.type == 'AMT') {
                        overAllPay = overAllPay +  parseInt(item.value);
                      }
                    }
                })
                // response.data[0].deductions.map((item: any) =>{
                //     if (item.type == '%') {
                //         overAllPay = overAllPay - ((overAllPay * item.value) / 100);
                //     } else if (item.type == 'AMT') {
                //         overAllPay = overAllPay - item.value;
                //     }   
                // })    
                // setCandidateFinalPay(overAllPay)
            }
        });
    }

    const S3_BUCKET = 'ellow-prod-doc-upload';
    const REGION = 'ap-south-1';

    AWS.config.update({
        accessKeyId: 'AKIAU2WIJEWHLXODZCYH',
        secretAccessKey: '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'
    })

    const myBucket = new AWS.S3({
        params: { Bucket: S3_BUCKET },
        region: REGION,

    })


    const onSubmit = () => {
       
        setShowMessage(true);
        if (errorMobile == '' && errorName == '' && errorBankName == '' && errorAccountNo == '' && errorIfsc == '' && errorBranch == '' && errorBillFrom === '' && errorPanNo == '') {
            let gridElement = document.querySelector("#basicDetails") as any;
            drawDOM(gridElement, { paperSize: "A4", landscape: true })
                .then((group) => {
                    return exportPDF(group);
                })
                .then((dataUri) => {
                    const fileName = `Invoice_${timesheetData[0]?.candidateName.replace(/\s/g, "")}_${timesheetData[0]?.position.replace(/\s/g, "")}_${timesheetData[0]?.month}_${timesheetData[0]?.year}.pdf`;
                    fetch(dataUri)
                        .then(b => b.arrayBuffer())
                        .then(buff => {
                            let value = {
                                "action":"putObject",
                                "filename":fileName
                              }
                              postAPI( REACT_APP_CANDIDATE_FREELANCER + '/resume-signed-url',value).then((data) => {
                                let signedUrl = data.url;
                                uploadApi(signedUrl, buff, 'application/pdf').then((response) => {
                                    
                                })
                              })
                            // const params = { Bucket: S3_BUCKET, Key: fileName, Body: buff };
                            // let s3Response = myBucket.putObject(params).promise();
                            let currentDate = new Date().getTime()
                            let body = {
                                "invoiceRaisedDate": currentDate,
                                "invoiceFileName": fileName
                            }
                            saveTimeSheetInvoiceDetail(timesheetId, body).then((response) => {
                                if (response && response.status === 1) {
                                    displayNotification()
                                    navigate('../timesheet', { state: { candidateId: candidateId , candidateJobId: candidateJobId} })
                                }

                            });

                        }).catch(e => console.log(e))


                });
        }
        // if (pdfExportComponent.current) {
        //     pdfExportComponent.current.save();
        // }
    }

    const displayNotification = () => {
        setNotification(true)
        setTimeout(() => {
            setNotification(false)
        }, 4000)
    }
    const onClose = () => {
        setNotification(false)
    }

    return (
        <div>
            <section className={Styles.dashboardWrapper}>
                <SideMenu menu={menu} />
                <div className={Styles.dashboardContent}>
                    <div className="contentBox mb-40">
                        <div className="innerPadd24" >
                            <div id="basicDetails">
                                <PDFExport

                                    ref={pdfExportComponent}
                                    paperSize="A4" margin="1cm"
                                    fileName={`Report for ${new Date().getFullYear()}`}
                                    author="KendoReact Team"
                                >
                                <div className={Styles.basicDetails}>
                                    <div className={Styles.headingWrap}>
                                        <div>
                                            <div className={Styles.headingtitle}>INVOICE</div>
                                            <p className={Styles.invoiceText}>{timesheetData && timesheetData[0]?.month} {timesheetData && timesheetData[0]?.year}</p>
                                        </div>
                                        <div>
                                            <img src={ellowLogo} />
                                        </div>
                                    </div>
                                    <div className={Styles.billInfoWrap}>
                                        <div className={Styles.invoiceBox}>
                                            <br></br>
                                            <label className={Styles.invoiceSubHead}>Bill From</label>
                                            <br></br>
                                            <FormAreaInput
                                                id="description"
                                                name="billFrom"
                                                value={billFrom}
                                                placeholder=""
                                                onChange={(e: any) => {
                                                    if (e.target.value != '') {
                                                        setErrorBillFrom('')
                                                    }
                                                    else {
                                                        setErrorBillFrom('This field is required')
                                                    }
                                                        setBillFrom(e.target.value)
                                                }}
                                            >
                                            </FormAreaInput>
                                            <p className={Styles.red}> {showMessage && errorBillFrom}</p>
                                            <br></br>
                                            <label className={Styles.invoiceSubHead}>Bill To</label>
                                            <br></br>
                                            <p className={Styles.billAddress}>Ellow Talent Marketplaces Pvt Ltd</p>
                                            <p className={Styles.billAddress}>Digital/Manual Signature is mandatory</p>
                                            <p className={Styles.billAddress}>Room No: 17, One seat #3 KINFRA, Infopark Second Floor</p>
                                            <p className={Styles.billAddress}>Geo Infopark KAKKANAD Ernakulam KL 682042 IN</p>
                                        </div>
                                        <div className={Styles.invoiceBox}>
                                            <div className={Styles.billInfo}>
                                                <div className={Styles.invoiceInfo}>
                                                    <div className={Styles.invoiceBox}>
                                                        <strong>Invoice No:</strong>
                                                        <label>{invoiceNo}</label>
                                                    </div>
                                                    <div className={Styles.invoiceBox}>
                                                        <strong>Employee Id:</strong>
                                                        <label>{employeeId}</label>
                                                    </div>
                                                    <div className={Styles.invoiceBox}>
                                                        <strong>Invoice Date:</strong>
                                                        <label>{today}</label>
                                                    </div>
                                                    <div className={Styles.invoiceBox}>
                                                        <strong>Amount Due:</strong>
                                                        <label>{timesheetData && timesheetData[0]?.candidateOverallPay}</label>
                                                    </div>
                                                </div>
                                                <br></br>
                                                <table className={Styles.tableStyle}>
                                                    <tbody>
                                                        <tr>
                                                            <td className={Styles.tdescription}>Mobile</td>
                                                            <td><input type="text" className={Styles.formbox} value={mobile}
                                                                onChange={(e: any) => {
                                                                    if (e.target.value != '') {
                                                                        setErrorMobile('')
                                                                    }
                                                                    else {
                                                                        setErrorMobile('This field is required')
                                                                    }
                                                                    setMobile(e.target.value)
                                                                }
                                                                }

                                                            />
                                                            <p className={Styles.red}> {showMessage && errorMobile}</p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className={Styles.tdescription}>Name as per the bank</td>
                                                            <td><input type="text" className={Styles.formbox} value={name}
                                                                onChange={(e: any) => {
                                                                    if (e.target.value != '') {
                                                                        setErrorName('')
                                                                    }
                                                                    else {
                                                                        setErrorName('This field is required')
                                                                    }
                                                                    setName(e.target.value)
                                                                }}
                                                                />
                                                                <p className={Styles.red}>{showMessage && errorName}</p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className={Styles.tdescription}>Bank Name</td>
                                                            <td><input type="text" className={Styles.formbox} value={bankName}
                                                                onChange={(e: any) => {
                                                                    if (e.target.value != '') {
                                                                        setErrorBankName('')
                                                                    }
                                                                    else {
                                                                        setErrorBankName('This field is required')
                                                                    }
                                                                    setBankName(e.target.value)
                                                                }}
                                                                />
                                                                <p className={Styles.red}>{showMessage && errorBankName}</p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className={Styles.tdescription}>Account No</td>
                                                            <td><input type="text" className={Styles.formbox}
                                                                value={accountNo}
                                                                onChange={(e: any) => {
                                                                    if (e.target.value != '') {
                                                                        setErrorAccountNo('')
                                                                    }
                                                                    else {
                                                                        setErrorAccountNo('This field is required')
                                                                    }
                                                                    setAccountNo(e.target.value)
                                                                }}
                                                                />
                                                                <p className={Styles.red}>{showMessage && errorAccountNo}</p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className={Styles.tdescription}>IFSC</td>
                                                            <td><input type="text" className={Styles.formbox}
                                                                value={ifsc}
                                                                onChange={(e: any) => {
                                                                    if (e.target.value != '') {
                                                                        setErrorIfsc('')
                                                                        }
                                                                    else {
                                                                        setErrorIfsc('This field is required')
                                                                    }
                                                                    setIfsc(e.target.value)
                                                                }}    
                                                                />
                                                                <p className={Styles.red}>{showMessage && errorIfsc}</p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className={Styles.tdescription}>Branch</td>
                                                            <td><input type="text" className={Styles.formbox}
                                                                value={branch}
                                                                onChange={(e: any) => {
                                                                    if (e.target.value != '') {
                                                                        setErrorBranch('')
                                                                    }
                                                                    else {
                                                                        setErrorBranch('This field is required')
                                                                    }
                                                                    setBranch(e.target.value)
                                                                }}   
                                                                />
                                                                <p className={Styles.red}>{showMessage && errorBranch}</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.invoiceTable}>
                                        <table className={Styles.tableStyle2} cellPadding='0' cellSpacing='0'>
                                            <tr>
                                                <th>No.</th>
                                                <th>Item</th>
                                                <th>Description</th>
                                                <th>Amount</th>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>{candidateName} & {companyName}</td>
                                                <td>{designation}</td>
                                                <td></td>
                                            </tr>
                                            <tr className={Styles.total}>
                                                <td colSpan={3}><div className='text-right'>Sub Total</div></td>
                                                <td>{candidatePay}</td>
                                            </tr>
                                            <tr className={Styles.total}>
                                                <td colSpan={3}><div className='text-right'>TDS</div></td>
                                                <td>{tdsAmount}</td>
                                            </tr>
                                            <tr className={Styles.total}>
                                                <td colSpan={3}><div className='text-right'>net Payable</div></td>
                                                <td>{netPayableAmount}</td>
                                            </tr>
                                            {/* <tr>
                                                <td colSpan={2} valign='top'>PAN : </td>
                                                <td colSpan={2} valign='top'>
                                                    <div>Signature</div>
                                                    <div className={Styles.signatureBlock}>
                                                        
                                                    </div>
                                                </td>
                                            </tr> */}  
                                        </table>
                                        <div className={Styles.totalBlock}>
                                            <div className={Styles.pan}>
                                                PAN
                                                <input type="text"
                                                    name="panNo"
                                                    value={panNo}
                                                    className={Styles.panfield}
                                                    onChange={(e: any) => {
                                                    if (e.target.value != '') {
                                                        setErrorPanNo('')
                                                        }
                                                        else {
                                                            setErrorPanNo('This field is required')
                                                        }
                                                            setPanNo(e.target.value)
                                                        }
                                                    }
                                                />
                                                <p className={Styles.red}>{showMessage && errorPanNo}</p>
                                            </div>
                                            {/* <div className={Styles.subTotal}>
                                                <span>Net Bill:</span><img src={rupeeIndian} className={Styles.indianRupee} /> {candidateOverallPay}
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </PDFExport>
                        </div>
                        <div className={Styles.totalBlock1}>
                            <div className={Styles.pan}>
                            </div>
                            <div >
                                <Button variant="primary" onClick={onSubmit}>Generate</Button>
                            </div>
                        </div>
                            {notification && <NotificationAlert onClose={onClose} closable={true} >Invoice Generated successfully </NotificationAlert>}
                        </div>
                    </div>
                </div>
            </section >
        </div >
    )
}

export default InvoiceGenerator;

